import moment from 'moment'

export const getCurrentMonthDayYearDate = () => {
  return new Date().toLocaleString('default', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const getMonthDayYearDate = (timestamp, isEpoch) => {
  return new Date(isEpoch ? timestamp * 1000 : timestamp).toLocaleString(
    'default',
    {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
  )
}

export const isDateDisabled = (date, defaultStartDate, defaultEndDate) => {
  // only allow days within 30 days of current date for Notifications and Webhooks events
  return (
    date.getTime() < defaultStartDate.getTime() ||
    date.getTime() > defaultEndDate.getTime()
  )
}

export const rangeLabel = (start, end) => {
  const duration = moment.duration(end.diff(start))
  const hours = Math.round(duration.asHours())

  const numValue = hours
  let label, suffix

  if (numValue === 1) {
    label = hours
    suffix = 'hour'
  } else if (numValue <= 24) {
    label = hours
    suffix = 'hours'
  } else {
    label = Math.round(hours / 24)
    suffix = 'days'
  }

  return { suffix, label }
}
